// extracted by mini-css-extract-plugin
export var border = "style-module--border--LkkFi";
export var divider = "style-module--divider--fmrwm";
export var dotsWrapper = "style-module--dotsWrapper--8voTZ";
export var gadgetPosition = "style-module--gadgetPosition--YlE3+";
export var gadgetPosition2 = "style-module--gadgetPosition2--qU0JB";
export var header = "style-module--header--PsYih";
export var imageWrapper = "style-module--imageWrapper--EUTUn";
export var linkedin = "style-module--linkedin--aJQWI";
export var mentor = "style-module--mentor--tmVKZ";
export var mentorImg = "style-module--mentorImg--8EuwR";
export var name = "style-module--name--w47vD";
export var root = "style-module--root--24BTn";
export var title = "style-module--title--9aVG4";